@keyframes cv1n320 {
  0% {
    transform: scale(1.05);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.cv1n321 {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.875rem;
  font-family: var(--xvl85n7j);
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--xvl85n18);
  background: transparent;
  border: 1px solid var(--xvl85n17);
  border-radius: 6px;
  box-shadow: 0 0 12px var(--xvl85n1a);
  white-space: nowrap;
  animation: cv1n320 var(--xvl85ndq) var(--xvl85ne7);
}
.cv1n322 {
  font-size: 0.75rem;
  padding: 0.375rem 0.625rem;
}
.cv1n323 {
  font-size: 0.875rem;
  padding: 0.625rem 1rem;
}
.cv1n324 {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--xvl85neg);
  box-shadow: 0 0 4px var(--xvl85nef);
}
.cv1n325 {
  display: inline-flex;
  align-items: baseline;
  gap: 0.3em;
}
.cv1n326 {
  font-family: var(--xvl85n7l);
  font-variant-numeric: tabular-nums;
}
.cv1n327 {
  color: var(--xvl85n18);
}
.cv1n328 {
  color: var(--xvl85n8m);
  margin: 0 0.15em;
}
.cv1n329 {
  font-family: var(--xvl85n7l);
  font-variant-numeric: tabular-nums;
  color: var(--xvl85n8j);
}
@media (prefers-reduced-motion: reduce) {
  .cv1n321 {
    animation: none;
  }
}